export default "__VITE_ASSET__4464172f__"